export class MiddleLangToQuery {
  static middleLangToQuery({ middleLang }) {
    const IOIds = middleLang.map(IO => {
      return IO.IOId
    })

    const BPIds = middleLang
      .map(IO => {
        const targetOpt = IO.BPIds.find(bp => bp.selected)

        return targetOpt ? [targetOpt.BPId] : []
      })
      .flat()

    return { IOIds, BPIds }
  }
}

export const middleLangToQuery = ({ middleLang }) =>
  MiddleLangToQuery.middleLangToQuery({ middleLang })
